import React from "react";
import { Link, Navigate } from "react-router-dom";
import KibliLogo from "../components/KibliLogo";
import { useAuth } from "../contexts/AuthContext";

export default function Landing() {
  const { user } = useAuth();
  if (user) return <Navigate to="/home" replace />;
  if (user === null) return null;

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-10 text-center">
      <div className="w-full max-w-md flex flex-col items-center gap-8 animate-fade-in-up">
        <KibliLogo size={88} />

        <div className="space-y-4">
          <h1 className="text-3xl md:text-5xl font-extrabold leading-tight tracking-tight text-slate-900">
            Encuentra canguros y profesores cerca de ti en minutos
          </h1>
          <p className="text-slate-500 text-base md:text-lg">
            La app que conecta a familias con los mejores cuidadores y profesores de tu zona
          </p>
        </div>

        <div className="w-full flex flex-col gap-3 text-left">
          <div className="flex items-center gap-3 text-slate-700">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-100 text-blue-600">
              <i className="fa-solid fa-location-dot"></i>
            </span>
            <span>Cerca de ti en tu ciudad</span>
          </div>
          <div className="flex items-center gap-3 text-slate-700">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-amber-100 text-amber-600">
              <i className="fa-solid fa-comments"></i>
            </span>
            <span>Chat directo</span>
          </div>
        </div>

        <div className="w-full flex flex-col gap-3 mt-2">
          <Link to="/login" className="btn-primary w-full py-4 text-base" data-testid="landing-login-btn">
            Iniciar sesión
          </Link>
          <Link to="/register" className="btn-outline w-full py-4 text-base" data-testid="landing-register-btn">
            Crear cuenta
          </Link>
        </div>
      </div>
    </div>
  );
}
